var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9829 0H0V19.9993H31.9829V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3925 11.9934V19.9993H17.5904V11.9934H31.9829V7.99528H17.5904V0H14.3925V7.99528H0V11.9934H14.3925Z",
    fill: "#CF142B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6571 6.47412V0H29.0134L18.6571 6.47412Z",
    fill: "#00247D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6572 13.5243V19.9984H29.0135L18.6572 13.5243Z",
    fill: "#00247D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3249 13.5243V19.9984H2.96973L13.3249 13.5243Z",
    fill: "#00247D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3249 6.47412V0H2.96973L13.3249 6.47412Z",
    fill: "#00247D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.85938V6.66707H7.68959L0 1.85938Z",
    fill: "#00247D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9828 1.8595V6.66719H24.2943L31.9828 1.8595Z",
    fill: "#00247D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9828 18.1406V13.3329H24.2943L31.9828 18.1406Z",
    fill: "#00247D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.1406V13.3329H7.68959L0 18.1406Z",
    fill: "#00247D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.983 0H30.207L19.5627 6.66677H21.3387L32.0001 0",
    fill: "#CF142B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4203 13.3329H10.6443L0 19.9986H1.776L12.4373 13.3329",
    fill: "#CF142B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88212 6.67098H10.6581L0 0V1.11797L8.88212 6.67098Z",
    fill: "#CF142B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0945 13.329H21.3185L31.9766 20V18.882L23.0945 13.329Z",
    fill: "#CF142B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUk);
export default __webpack_public_path__ + "static/media/flag-uk.2a1eb8e6c6ee8258936c35e7a9e17f30.svg";
export { ForwardRef as ReactComponent };